/* MESS Shop: mobile nav, variant picker, gallery, AJAX add to cart, sort select.
   Every feature degrades to plain HTML: forms still POST to /cart/add without JS. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- mobile nav (header.php inline script, same behaviour) ---------- */
  function initNav() {
    var t = document.querySelector('.mess-nav-toggle');
    var m = document.getElementById('mess-mobile-nav');
    if (!t || !m) return;
    function close() {
      m.classList.remove('open');
      t.setAttribute('aria-expanded', 'false');
      t.setAttribute('aria-label', 'Open menu');
    }
    t.addEventListener('click', function () {
      var open = m.classList.toggle('open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      t.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    m.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && m.classList.contains('open')) { close(); t.focus(); }
    });
  }

  /* ---------- toast + cart count ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var el = document.getElementById('mess-toast');
    if (!el) return;
    el.querySelector('[data-toast-msg]').textContent = msg;
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('show'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('show');
      setTimeout(function () { if (!el.classList.contains('show')) el.hidden = true; }, 300);
    }, 4500);
  }
  function refreshCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) {
          n.textContent = cart.item_count;
          n.hidden = !cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ---------- AJAX add to cart (cards + product form) ---------- */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-mess-atc-form]')) return;
      if (!window.fetch || !window.FormData) return; // plain POST fallback
      // a click on Shop Pay / dynamic checkout never reaches here; this is Add to cart only
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn && btn.disabled) return;
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            toast((res.body && (res.body.description || res.body.message)) || 'Could not add that to the cart.', true);
            return;
          }
          toast('Added to cart.');
          refreshCount();
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        });
    });
  }

  /* ---------- product gallery: thumbnail swaps the main image in place ---------- */
  function showMedia(gallery, mediaId) {
    if (!gallery) return;
    var btn = gallery.querySelector('[data-media-id="' + mediaId + '"]');
    var main = gallery.querySelector('[data-gallery-main]');
    if (!btn || !main) return;
    main.style.opacity = '0';
    setTimeout(function () {
      main.src = btn.getAttribute('data-src');
      main.srcset = btn.getAttribute('data-srcset') || '';
      main.alt = btn.getAttribute('data-alt') || '';
      main.style.opacity = '1';
    }, 120);
    gallery.querySelectorAll('[data-media-id]').forEach(function (b) {
      b.setAttribute('aria-current', b === btn ? 'true' : 'false');
    });
  }
  function initGallery() {
    document.querySelectorAll('[data-mess-gallery]').forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-media-id]');
        if (!b) return;
        showMedia(g, b.getAttribute('data-media-id'));
      });
    });
  }

  /* ---------- variant picker ---------- */
  function initVariants() {
    document.querySelectorAll('[data-mess-product]').forEach(function (wrap) {
      var dataEl = wrap.querySelector('[data-mess-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var fieldsets = wrap.querySelectorAll('[data-mess-opt]');
      if (!fieldsets.length) return;
      var idInput = wrap.querySelector('[data-mess-variant-id]');
      var priceEl = wrap.querySelector('[data-mess-price]');
      var atc = wrap.querySelector('[data-mess-atc]');
      var gallery = wrap.querySelector('[data-mess-gallery]');

      function selected() {
        return Array.prototype.map.call(fieldsets, function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      function match(opts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function markAvailability(opts) {
        fieldsets.forEach(function (fs, idx) {
          fs.querySelectorAll('.mess-pill').forEach(function (pill) {
            var val = pill.querySelector('input').value;
            var test = opts.slice(); test[idx] = val;
            var v = match(test);
            // a real but sold-out combination is struck through; a combination that does
            // not exist is not (picking it snaps the other options to a real variant)
            var off = v ? !v.available : !variants.some(function (x) { return x.options[idx] === val && x.available; });
            pill.classList.toggle('is-unavailable', off);
          });
          var lab = fs.querySelector('[data-opt-selected]');
          if (lab) lab.textContent = opts[idx] || '';
        });
      }
      function setRadios(opts) {
        fieldsets.forEach(function (fs, idx) {
          fs.querySelectorAll('input').forEach(function (r) { r.checked = r.value === opts[idx]; });
        });
      }
      function update(e) {
        var opts = selected();
        var v = match(opts);
        if (!v && e && e.currentTarget) {
          // that combination does not exist: keep the value just picked and move the
          // other options to the closest real variant (available ones first)
          var idx = Array.prototype.indexOf.call(fieldsets, e.currentTarget);
          var picked = opts[idx], best = null;
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].options[idx] !== picked) continue;
            if (!best || (!best.available && variants[i].available)) best = variants[i];
          }
          if (best) { opts = best.options.slice(); setRadios(opts); v = best; }
        }
        markAvailability(opts);
        if (!v) {
          if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = v.compare ? '<del>' + v.compare + '</del> <ins>' + v.price + '</ins>' : v.price;
        }
        if (atc) {
          atc.disabled = !v.available;
          atc.textContent = v.available ? 'Add to cart' : 'Sold out';
        }
        if (v.media && gallery) showMedia(gallery, String(v.media));
        if (window.history && history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
      markAvailability(selected());
    });
  }

  /* ---------- collection sort select ---------- */
  function initSort() {
    document.querySelectorAll('[data-mess-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
  }

  function init() { initNav(); initAddToCart(); initGallery(); initVariants(); initSort(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
